module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/RatingLabel/images/stronghold_rating_label_bg-disabled.65e83507.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/RatingLabel/images/stronghold_rating_label_bg-disabled.png
// module id = 3404
// module chunks = 11